import styled from 'styled-components'
import { typography } from 'styled-system'
import Box from 'wrappers/Box';

const Text = styled('div')`
  ${typography}
`

export default Text
